import React from "react";
import EditIcon from "../../../../assets/svgs/Edit.jsx";

const BasicDetails = () => {
  return (
    <div className="rounded-lg shadow-xl ">
      <div className="flex flex-col py-5 mb-10 text-sm sm:text-base">
        <div className="flex justify-between py-4 px-5 md:px-9 text-base sm:text-lg">
          <p className="text-lg font-semibold">Basic Details</p>
          <button className="flex space-x-1">
            <EditIcon />
            <span>Edit Info</span>
          </button>
        </div>

        <div className="space-y-4 px-9 py-2">
          <div className="w-full sm:w-2/4 inline-flex flex-col">
            <h3 className="font-medium">Email</h3>
            <p className="text-xs">ckctm12@gmail.com</p>
          </div>
          <div className="w-full sm:w-2/4 inline-flex flex-col">
            <h3 className="font-medium">Address</h3>
            <p className="text-xs">
              P Janardhan Reddy Nagar, Gachibowli, Hyderabad, Telangana 500081
            </p>
          </div>
          <div className="w-full sm:w-2/4 inline-flex flex-col">
            <h3 className="font-medium">Phone Number</h3>
            <p className="text-xs">+913242553344</p>
          </div>
          <div className="w-full sm:w-2/4 inline-flex flex-col">
            <h3 className="font-medium">Country</h3>
            <p className="text-xs">India</p>
          </div>
          <div className="w-full sm:w-2/4 inline-flex flex-col">
            <h3 className="font-medium">Name</h3>
            <p className="text-xs">Jane Cooper</p>
          </div>
          <div className="w-full sm:w-2/4 inline-flex flex-col">
            <h3 className="font-medium">Candidate_Id</h3>
            <p className="text-xs">10934JC</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicDetails;
